import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { appNamedRoutes } from 'routes';
import PageSubNav from 'components/nav/PageSubNav';

const AdministrationSubNav = () => {
  const { t } = useTranslation();
  const maxPermissions = useSelector(state => state.auth.isMaxPermissions);

  const ADMINISTRATION_PAGES = [
    { path: appNamedRoutes.administrationStaff, label: t('administration.subNav.staff') },
    { path: appNamedRoutes.administrationOrganization, label: t('administration.subNav.organization') },
    { path: appNamedRoutes.administrationFamilies, label: t('administration.subNav.families') },
  ];

  // Reporting is a Max Permission page. Hiding the tab is a convenience only —
  // the API enforces the same restriction.
  if (maxPermissions) {
    ADMINISTRATION_PAGES.push({
      path: appNamedRoutes.administrationReporting,
      label: t('administration.subNav.reporting'),
    });
  }

  return (
    <PageSubNav items={ADMINISTRATION_PAGES} />
  );
};

export default AdministrationSubNav;
